import { z } from 'zod';

export const frequencyBudgetSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  userId: z.string().nullable(),
  messageCategory: z.string(),
  weeklyLimit: z.number(),
  currentCount: z.number(),
  weekStartsAt: z.string(),
  /** `cac` cuando la fila la declara el CaC de la app. */
  managedBy: z.string().nullable().optional(),
});
export type FrequencyBudget = z.infer<typeof frequencyBudgetSchema>;

export const budgetInputSchema = z.object({
  tenantId: z.string().nullable().optional(),
  userId: z.string().nullable().optional(),
  messageCategory: z.string(),
  weeklyLimit: z.number().min(1),
});
export type BudgetInput = z.infer<typeof budgetInputSchema>;

export const budgetUsageSchema = z.object({
  messageCategory: z.string(),
  weeklyLimit: z.number(),
  currentCount: z.number(),
  remaining: z.number(),
  weekStartsAt: z.string(),
});
export type BudgetUsage = z.infer<typeof budgetUsageSchema>;
